import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type NowSlotExtended } from '@redteclab/api/clients/bully'

import { nowBasicCheckRespGetSlotShippingIsToday } from '../../../../../now'

export const ProductBuyBoxNowInfoDay: FC<{ nowSlot: NowSlotExtended }> = ({
  nowSlot,
}) => {
  const shippingIsToday = nowBasicCheckRespGetSlotShippingIsToday(nowSlot)

  return (
    <span className="mr-1 font-bold text-dark-now">
      {shippingIsToday ? (
        <FormattedMessage id="nowCountdown.shipTodayLabel" />
      ) : (
        <FormattedMessage id="nowCountdown.shopTomorrowLabel" />
      )}
    </span>
  )
}
